// extracted by mini-css-extract-plugin
module.exports = {"container":"Modal_container__Kxxo7","titleContainer":"Modal_titleContainer__P_Z37","closeButton":"Modal_closeButton__co9W1"};